import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const ListElement = ({ name, icon, targetUrl, topElement, children }) => {
  const location = useLocation();
  const isActive = targetUrl && location.pathname.startsWith(targetUrl);
  const [open, setOpen] = useState(!!isActive);
  const [hovered, setHovered] = useState(false);
  const hasChildren = typeof children !== "undefined";

  const linkStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "9px 12px 9px 24px",
    marginRight: "12px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: isActive ? 700 : 500,
    fontSize: "0.92rem",
    color: isActive ? "#1a73e8" : hovered ? "#1a73e8" : "#424242",
    background: isActive ? "#e8f0fe" : hovered ? "#f5f9ff" : "transparent",
    transition: "background 0.15s, color 0.15s",
    cursor: "pointer",
  };

  const handleClick = (e) => {
    if (topElement) {
      e.preventDefault();
      setOpen(!open);
    }
  };

  return (
    <li style={{ listStyle: "none" }}>
      <Link
        to={targetUrl || "#"}
        style={linkStyle}
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {icon && (
          <span style={{
            width: "20px",
            textAlign: "center",
            fontSize: "1rem",
            color: isActive ? "#1a73e8" : "#9e9e9e",
            flexShrink: 0,
          }}>
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
        <span style={{ flex: 1 }}>{name}</span>
        {hasChildren && (
          <FontAwesomeIcon
            icon={open ? faChevronDown : faChevronRight}
            style={{ fontSize: "0.65rem", color: "#bdbdbd" }}
          />
        )}
      </Link>

      {hasChildren && open && (
        <div>{children}</div>
      )}
    </li>
  );
};

export default ListElement;
